/*
 * Handles for all navigation on the results page including handling hashed urls
 * as well as links on the page getting clicked
 */
(function($) {
    var selectors = {
        linksToIgnore: '.js-results-link-full-refresh',
        navigationList: '#results-navigation-list',
        page: '#results-page',
        resources: '#results-resources',
        scrollCapture: '.js-scroll-capture',
        srResultsStatus: '#sr-results-status',
        resultsSortSelect: '.results-sort-select',
        resultsSortBtnLabel: '#results-sort-btn-label'
    };

    var storedURL = location.href;

    //helper method that retrieves the current relative url
    function getCurrentUrl() {
        return location.href.substr(location.origin.length);
    }

    //gets called after the $.get and looks up open facet nav
    function restoreFacetNav() {
        var openAccordions = evo.sessionStorage.getItem('openAccordions'),
            openViewMoreLinks = evo.sessionStorage.getItem('openViewMoreLinks');

        if (openAccordions && openAccordions.length > 0) {
            $(openAccordions).addClass('active').next('.js-mobile-accordion-content').show();
        }

        if (openViewMoreLinks && openViewMoreLinks.length > 0) {
            $(openViewMoreLinks).addClass('facet-open');
        }
    };

    //#region Scroll Management
    //helper that manages the scroll position of the page
    var scrollManager = (function scrollManager() {
        var that = this,
            scrollInfo = null;

        //if the link is a inside a scroll capture, we need to
        //save the scroll information before the ajax call
        //so that we can restore the user's position on the page
        that.recordScrollPosition = function($link) {
            var $scrollCapture = $link ? $link.closest(selectors.scrollCapture) : null;
            if ($scrollCapture && $scrollCapture.attr('id')) {
                scrollInfo = {
                    id: $scrollCapture.attr('id'),
                    top: $scrollCapture.offset().top
                };
            } else {
                scrollInfo = null;
            }

            //save the overall scroll position so that it can later be used with history restoration
            window.name += '||' + currentUrl + '_' + evo.$.window.scrollTop() + '!';
        };

        //fixes the user's scroll based on an action (click)
        //if scrollInfo has a value, we scroll to that same new element
        //otherwise, we scroll to the top of the page
        that.restoreScrollForAction = function() {
            if (scrollInfo !== null) {
                var $newScrollCapture = $('#' + scrollInfo.id);
                if ($newScrollCapture.size()) {
                    var scrollTopDiff = $newScrollCapture.offset().top - scrollInfo.top;

                    //reset our stored info so that it doesn't trigger again
                    scrollInfo = null;

                    //if we're in mobile we need to scroll the navigation and not the whole window
                    if (evo.isMobile) {
                        $(selectors.navigationList).get(0).scrollTop += scrollTopDiff;
                    } else {
                        window.scrollBy(0, scrollTopDiff);
                        return;
                    }
                }
            }

            var scrollTop = page.offset().top;
            if (evo.$.window.scrollTop() > scrollTop) {
                window.scrollTo(0, scrollTop);
            }
        };

        //restores the user's scroll position to that which was saved for the current url
        that.restoreScrollForHistoryChange = function() {
            //try using the stored value in the window.name value
            var name = window.name,
                scrollTop = null,
                url = currentUrl,
                indexOfPipes = name.lastIndexOf('||' + url + '_'),
                indexOfExclamation = name.indexOf('!', indexOfPipes);

            if (indexOfPipes >= 0 && indexOfExclamation > indexOfPipes) {
                var rawScrollValue = name.substring(indexOfPipes + url.length + 3, indexOfExclamation);
                scrollTop = parseInt(rawScrollValue, 10);
            }

            if (!isNaN(scrollTop)) {
                window.scrollTo(0, scrollTop);
            }
        };

        return that;
    })();
    //#endregion

    //#region Navigation Management
    //helper that manages the ajax navigation of the page
    var navigationManager = (function() {
        var that = this,
            resultsLinkStart = /((\/\w*)?\/(outlet-)?shop)/.exec(location.href)[0],
            currentRequest = null;

        //returns true if the value is a valid results url
        that.isResultsUrl = function(url) {
            return url && url.indexOf(resultsLinkStart) >= 0;
        };

        //navigates the user to the given url using an ajax refresh
        that.navigate = function (url) {
            if (currentRequest !== null) {
                currentRequest.abort();
            }
            currentUrl = url;
          
            page.addClass('loading');
            
            currentRequest = $.get(url).done(function(response) {
                
                var $response = $(response);
                var $newPage = $response.find(selectors.page).addBack(selectors.page);
                if (!$newPage.size()) {
                    return;
                }

                page.html($newPage.html());

                // updates a div with `aria-live` to indicate that the product results are updated to screen readers
                // setTimeout is included because reading of this field in a SR is buggy unless it happens a chunk of time after the results refresh.
                setTimeout(function() {
                        $(selectors.srResultsStatus).text('Product Results Updated');
                    },
                    100);

                var $resources = $response.find(selectors.resources).addBack(selectors.resources);
                if (!$resources.size()) {
                    return;
                }
                $('head').append($resources.children());
            }).always(function() {
                page.removeClass('loading');
                restoreFacetNav();
                currentRequest = null;

                updateSortLabel();

                dataLayerManager.push({
                    event: "virtual-page-view",
                    title: document.title,
                    url: url
                });


                page.trigger('refresh.results');
            });

            return currentRequest;
        };

        //helper method that cleans results urls
        that.sanitizeUrl = function (url) {
            //trim off any leading hash sign if there is one
            if (url[0] === '#') {
                url = url.substring(1);
            }

            return url;
        }

        return that;
    })();
    //#endregion

    var page = $(selectors.page),
        currentUrl = getCurrentUrl();

    page.on('click',
        'a',
        function(e) {
            var $link = $(this),
                href = $link.attr('href');

            //make sure this is a valid results link that allows ajax handling
            if (!navigationManager.isResultsUrl(href) || $link.is(selectors.linksToIgnore)) {
                return;
            }

            e.preventDefault();

            //record scroll position before the ajax call
            scrollManager.recordScrollPosition($link);

            //navigate the user
            href = navigationManager.sanitizeUrl(href);
            history.pushState(null, null, href);

            //"Did you mean?" links require full page load
            if ($link.data("did-you-mean")) {
                window.location.href = href;
                return;
            }
            navigationManager.navigate(href, $link).always(function () {
                
                //now that the html is updated, restore the user's scroll
                scrollManager.restoreScrollForAction();
            });
        });

    //Handle click on facet values so they act checked before ajax request
    page.on('click',
        '.facet-value-li a, .view-only-list a',
        function() {
            $(this).addClass('facet-loading');
        });

    var updateSortLabel = function() {
        var $sortBtnLabel = page.find(selectors.resultsSortBtnLabel),
            $sortSelect = $('.results-sort-select-mobile');

        $sortBtnLabel.text($sortSelect.find('option:selected').text());
        $sortSelect.blur();
    };
    updateSortLabel();

    page.on('change',
        selectors.resultsSortSelect,
        function() {
            var $this = $(this),
                href = $this.val();

            //make sure this is a valid results link that allows ajax handling
            if (!navigationManager.isResultsUrl(href)) {
                return;
            }

            updateSortLabel();

            //record scroll position before the ajax call
            scrollManager.recordScrollPosition($this);

            //navigate the user
            href = navigationManager.sanitizeUrl(href);
            history.pushState(null, null, href);
            navigationManager.navigate(href, $this).always(function() {
                //now that the html is updated, restore the user's scroll
                scrollManager.restoreScrollForAction();
            });
        });

    page.on('refresh.results',
        function() {
            //update the storedURL for back navigation
            storedURL = location.href;
        });

    //handler for history state changes (i.e. back/forward button for ajax calls)

    evo.$.window.on('popstate',
        function(e) {
            //browsers don't implement the initial history state
            //the same, so this code ensures we're only executing update
            //code when we need to

            if (location.href === storedURL) {
                return;
            }

            //record scroll position before the ajax call
            scrollManager.recordScrollPosition();

            navigationManager.navigate(getCurrentUrl()).done(function() {
                //now that the html is updated, restore the user's scroll
                scrollManager.restoreScrollForHistoryChange();
            });;
        });

    //Hides and shows the individutal facet items and sets a sessionStorage Value for what is open
    page.on('click',
        '.js-facet-collapse-toggle',
        function(e) {
            e.preventDefault();
            $(this).closest('.facet').toggleClass('facet-open');
            page.trigger("sticky_kit:recalc");

            var openedFacets = $('#results-sidebar .facet-open').map(function() {
                return '#' + this.id;
            }).get().join(',');

            evo.sessionStorage.setItem('openViewMoreLinks', openedFacets);
        });

    //Hides and shows the category list
    page.on('click',
        '.js-category-collapse-toggle',
        function() {
            $(this).closest('.category-list').toggleClass('category-open');
        });
})(jQuery);